class CountdownTimer {
  constructor(element) {
    this.element = element;
    const daysToAdd = parseInt(element.dataset.days, 10);

    // Bereken einddatum (vandaag + aantal dagen, om 23:59:59)
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + daysToAdd);
    endDate.setHours(23, 59, 59, 999);
    this.endTime = endDate.getTime();

    if (isNaN(this.endTime)) {
      console.error("Ongeldige aantal dagen:", element.dataset.days);
      this.element.innerHTML = "ONGELDIGE INVOER";
      return;
    }

    this.daysSpan = element.querySelector(".days");
    this.hoursSpan = element.querySelector(".hours");
    this.minutesSpan = element.querySelector(".minutes");
    this.secondsSpan = element.querySelector(".seconds");

    this.updateTimer();
    setInterval(() => this.updateTimer(), 1000);
  }

  updateTimer() {
    const now = new Date().getTime();
    const distance = this.endTime - now;

    if (distance < 0) {
      this.element.innerHTML = "VERLOPEN";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.daysSpan.textContent = String(days).padStart(2, "0");
    this.hoursSpan.textContent = String(hours).padStart(2, "0");
    this.minutesSpan.textContent = String(minutes).padStart(2, "0");
    this.secondsSpan.textContent = String(seconds).padStart(2, "0");

    const dayTextElement = this.element.querySelector(".day-text");
    dayTextElement.textContent = days === 1 ? "dag" : "dagen";
  }
}

document
  .querySelectorAll(".timer")
  .forEach((timer) => new CountdownTimer(timer));
